import { render, staticRenderFns } from "./menu-icon.vue?vue&type=template&id=438cf704&scoped=true&"
import script from "./menu-icon.vue?vue&type=script&lang=js&"
export * from "./menu-icon.vue?vue&type=script&lang=js&"
import style0 from "./menu-icon.vue?vue&type=style&index=0&id=438cf704&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438cf704",
  null
  
)

export default component.exports